import { render, staticRenderFns } from "./OrderOpGoodsInfoCard.vue?vue&type=template&id=25cf9fb9"
import script from "./OrderOpGoodsInfoCard.vue?vue&type=script&lang=js"
export * from "./OrderOpGoodsInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports